module.exports = __webpack_public_path__ + "static/book-jacket-a460ab453c926b50feb22558529097da.jpg";